import Event from './eventBus';

class Present{
    constructor(config = {}, message) {
        this.presentDatas = [];
        this.message = message || {};
        this.init(config);
    }

    init(config) {
        // this.message = config.message;
        // this.receivePresentDatasFromMessageCenter();
        this.event = Event;
        this.initCustomEvent();
    }

    initCustomEvent() {
        this.receiveUserBalanceFromMessageCenter();
        this.receiveSilverDateFromMessageCenter();
        this.receivePresentDatasFromMessageCenter();

        this.event.on('send-present', this.boardcastPresentDataToMessageCenter.bind(this));
        this.event.on('send-goldEggData', this.boardcastSliverDataToMessageCenter.bind(this));
    }

    //[{ "id": 0, "type": "rose", "giftName": "玫瑰", "level": 1, "serial": 1, "personName": "aaa" }]
    //广播礼物数据到消息中心
    boardcastPresentDataToMessageCenter(presentData) {
        var _this = this;

        let _resHandle = function(fn) {
            return (res) => {
                if (res.code != 1) {
                    return;
                }
                console.log(`接受res.data`)
                if(fn) return fn(res.data);
                else return
            }
        }

        this.message
            .send('gift', 102, presentData)
            .then(_resHandle())
            .catch((error) => console.log(error));
    }

    // 从消息中心接受礼物数据
    receivePresentDatasFromMessageCenter() {
        var _this = this;
        let _resHandle = (res) => {
            if (res.code != 1) {
                console.log(res.message)
                return;
            }
            // console.log(res.data)
            this._addPresentData(res.data)
            this.event.trigger('receive-presentDatas', this.presentDatas);
        }
        this.message.on('gift:list', 204, _resHandle);
    }

    // 注册当前用户发送礼物事件
    // registerCurrentUserSendPresentData(fn) {
    //     let _resHandle = function(fn) {
    //         return (res) => {
    //             if (res.code != 1) {
    //                 return;
    //             }
    //             console.log(res.data)
    //             // this._addPresentData(res.data)
    //             // return fn(res.data);
    //         }
    //     }
    //     this.message.on('gift:list', 203, _resHandle(fn));
    // }

    // 广播金蛋数据到消息中心
    boardcastSliverDataToMessageCenter(sliverData) {
        var _this = this;
        return this.message
            .send('gift', 101, sliverData)
            .then(data => {
                console.log(data);
                return data;
            })
            .catch((error) => console.log(error))
    }

    // 从消息中心接受金蛋数据
    receiveSilverDateFromMessageCenter() {
        console.log(2222)
        var _this = this;
        let _resHandle = (res) => {
            if (res.code != 1) {
                console.log(res.message)
                return;
            }
            console.log(res.data)
            // _this.boardcastSliverDataToMessageCenter({id:res.data.id})
            this.event.trigger('recieve-goldEggData', res.data);
        }

        this.message.on('gift:sliver', 202, _resHandle);
    }

    // 从消息中心获取用户余额信息
    receiveUserBalanceFromMessageCenter(fn) {
        var _this = this;
        let _resHandle = res => {
            if (res.code != 1) {
                console.log(res.message)
                return;
            }
            console.log(`203======>`,res.data)
            _this.event.trigger('present-user-balance', res.data);
        }

        this.message.on('gift:user', 201, _resHandle);
        this.message.on('gift:balance', 203, _resHandle);
    }

    // 添加礼物数据
    _addPresentData(datas = []) {
        if (!datas.length) return;

        let _data = zipArray(this.presentDatas, datas.map(unzipObject));
        // console.log(_data[0])
        this.presentDatas = _data;
        // console.log(this.presentDatas)
    }

    // 通过comboid获得礼物数据
    getPresentDataByComboid(comboid) {
        
        if(!comboid) return;

        if (this.presentDatas.length) {
            let _data = this.presentDatas.filter(d => d.comboid === comboid);
            if(_data.length) {
                return _data[0];
            } else {
                return {};
            }
        }

        return {};
    }

    getPresentDatas() {
        return this.presentDatas;
    }

    removePresentData(data) {
        let _index = null;
        // console.log(`removebefore=====>${this.presentDatas.length}`);
        // console.log(data,this.presentDatas[0])
        for(let i = 0 ; i < this.presentDatas.length ; i++) {
            let _comboid = this.presentDatas[i].comboid;
            let _combo = this.presentDatas[i].combo;
            // console.log(this.presentDatas[i])
            if(_comboid == data.comboid && _combo == data.combo) {

                this.presentDatas.splice(i, 1);
                i--;
            }

        }

        // console.log(`removeafter=====>${this.presentDatas.length}`);
        
    }

    isLogin() {
        return this.message.getUser()
            .then(res => {
                if (res.type == 'user') {
                    return 'user';
                } else if (res.type == 'guest') {
                    return 'guest';
                }
            });
    }

}

export default Present;


// 格式化礼物数据
function unzipObject(obj = {}) {
    // console.log(JSON.stringify(obj))
    if(obj.gift && obj.gift.comboid) {
        return {
            id: obj.gift.id,
            comboid: obj.gift.comboid,
            combo: obj.gift.combo,
            nickname: obj.user.nickname,
            avatar: obj.user.avatar
        }
    }

    return {}
}

// 合并接收到的礼物数据到当前礼物数据池
function zipArray(map = [], map1 = []) {
    // console.log(map1)
    // let map = map;
    // let map1 = map1;
    if(!map.length) {
        if(map1.length) {
            return map1;
        } else {
            return [];
        }
    }

    for(let i = 0 ; i < map.length ; i++) {
        let _m = map[i];
        if(_m && _m.comboid) {

            for(let j = 0 ; j < map1.length ; j++){
                let _m1 = map1[j];
                if(_m1 && _m1.comboid) {

                    if(_m.comboid === _m1.comboid) {
                        if(_m1.combo > _m.combo) {
                            map[i] = _m1;
                        }

                        map1.splice(j,1);
                        j--;
                    } 
                } else {
                    map1.splice(j,1);
                    j--;
                }
            }
        }
        
    }
    // console.log(map,map1)
    if(map1.length) {
        return map.concat(map1)
    }
    
    return map;
}



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.gift.mobile/app/lib/present.js